import React from 'react';
import { FusedRecord } from '../../core/types/fusion';

interface DataViewProps {
  records: FusedRecord[];
}

export const DataView: React.FC<DataViewProps> = ({ records }) => {
  const recentRecords = records.slice(-50).reverse();

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
          融合实验记录 preview (最新 50 条记录，共 {records.length} 条)
        </div>
      </div>

      <div className="camera-card" style={{ overflowX: 'auto' }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Monotonic (ms)</th>
              <th>dBFS</th>
              <th>F0 (Hz)</th>
              <th>Centroid (Hz)</th>
              <th>Cam A Status</th>
              <th>Cam A (X, Y)</th>
              <th>Diff A (ms)</th>
              <th>Match Status</th>
            </tr>
          </thead>
          <tbody>
            {recentRecords.length === 0 ? (
              <tr>
                <td colSpan={9} style={{ textAlign: 'center', color: '#64748b', padding: '24px' }}>
                  暂无融合数据，请点击【开始采集】
                </td>
              </tr>
            ) : (
              recentRecords.map((r) => (
                <tr key={r.sequence}>
                  <td>{r.sequence}</td>
                  <td>{r.monotonicMs.toFixed(1)}</td>
                  <td>{r.audioFeatures.dbfs.toFixed(1)} dBFS</td>
                  <td>{r.audioFeatures.dominantFrequencyHz} Hz</td>
                  <td>{r.audioFeatures.spectralCentroidHz} Hz</td>
                  <td>
                    <span style={{ color: r.cameraAPosition?.status === 'tracking' ? '#84cc16' : '#ef4444' }}>
                      {r.cameraAPosition?.status || 'missing'}
                    </span>
                  </td>
                  <td>
                    {r.cameraAPosition && r.cameraAPosition.status === 'tracking'
                      ? `(${r.cameraAPosition.filteredPosition.x.toFixed(0)}, ${r.cameraAPosition.filteredPosition.y.toFixed(0)})`
                      : '-'}
                  </td>
                  <td>{r.cameraATimeDiffMs !== undefined ? `${r.cameraATimeDiffMs.toFixed(1)}ms` : '-'}</td>
                  <td>
                    <span className={`status-badge ${r.matchStatus === 'matched' ? 'status-running' : 'status-degraded'}`}>
                      {r.matchStatus}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
